import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

const RouteWithSubRoutes = (route) => {
  //CONTEXT
  const { user } = useAuth0();
  /**
   * macheamos el array de datos obligatorios (requiredValues) con el estado del User
   * si encotramos que falta uno hacemos redirect al page q indica el protected
   */
  const renderProtectedRoute = (props) => {
    const { requiredValues } = route.protected;
    const arr = Array.from(requiredValues).filter((item) => !!!user[item]);
    const isfail = arr.length > 0;

    return isfail ? (
      <Redirect to={route.protected.redirect} />
    ) : (
      <route.component {...props} {...route} routes={route.routes} />
    );
  };

  /**
    * handle el cual preg si la page es proteguida
    * si es true return fn el cual aplica logica de proteccion
    *   protected: {
          requiredValues: ["Email"],
          redirect: Ingresar,
        },
   */
  const handleProtectedRoute = (props) => {
    if (!route.protected)
      return <route.component {...props} {...route} routes={route.routes} />;

    return renderProtectedRoute(props);
  };

  return (
    <Route path={route.path} render={(props) => handleProtectedRoute(props)} />
  );
};

export default RouteWithSubRoutes;
